// Layouts

// Component
import MerchantOnboardStatusTable from './MerchantOnboardStatusTable';

// Libraries
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Style
import './MerchantOnboardStatus.scss';

const MerchantOnboardStatus = ({ auth, actions }) => {
    // const { userLevel } = auth.userDetails;

    return (
        <>
            <div className="merchant-onboard-status">
                <MerchantOnboardStatusTable />
            </div>
        </>
    );
};

const mapStateToProps = ({ auth, loader, actions }) => ({
    auth,
    loader,
    actions,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

MerchantOnboardStatus.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    loader: PropTypes.object,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MerchantOnboardStatus);
